import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/home/banners-with-text.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/home/banners.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/home/brands.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/home/products-list.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/sliders/categories-slider.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/ui/sliders/deals-slider.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/ui/sliders/grid-products-slider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/sliders/hero-slider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/sliders/products-slider.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/ui/sliders/testimonials-slider.js");
